import { Box } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";

import { useImageQueriesTableContext } from "../context";

import { EmptyState } from "./emptyMessage/EmptyMessage";

export function NoRowsOverlay() {
  const { detector, hasDetectors } = useImageQueriesTableContext();

  if (!hasDetectors) {
    return (
      <EmptyState firstListItem="Account has no image queries to load. Once you've submitted image queries to a detector they will appear here." />
    );
  }

  if (!detector) {
    return (
      <Box className="flex w-full h-full items-center justify-center">
        <Typography className="text-neutral-dark">
          Use dropdown in upper left to select detector to show data from
        </Typography>
      </Box>
    );
  }

  return (
    <EmptyState
      firstListItem={`${detector.name} has no image queries to load. Once you’ve submitted image queries to this detector they will appear here.`}
    />
  );
}
